import dataPerson from './date-person';
import dateSceen from './date-sceen';

interface Idate {
  img: string,
  numberQuestion: number
}

class ModelCategorie {
  datePerson: Array<Idate>;

  dateScene: Array<Idate>;

  activeCategoria: string;

  constructor() {
    this.datePerson = ModelCategorie.localDate('person');
    this.dateScene = ModelCategorie.localDate('sceen');
    this.activeCategoria = 'person';
  }

  static localDate(type: string): Array<Idate> {
    let date;
    if (type === 'sceen') date = localStorage.getItem('chromari-categorie-sceen');
    else date = localStorage.getItem('chromari-categorie-person');

    if (date) return JSON.parse(date);
    return (type === 'sceen') ? dateSceen : dataPerson;
  }

  commit() {
    localStorage.setItem('chromari-categorie-sceen', JSON.stringify(this.dateScene));
    localStorage.setItem('chromari-categorie-person', JSON.stringify(this.datePerson));
  }

  updateCategorieDate(type: string, card: number, cardQuestion: number) {
    if (type === 'scene') this.dateScene[card].numberQuestion = cardQuestion;
    else this.datePerson[card].numberQuestion = cardQuestion;

    this.commit();
  }
}

export default ModelCategorie;
